<template lang="pug">
    .google-recaptcha-keys(v-if="k >= 0")
        h4
            i.el-icon-fa-shield-alt.fas
            | {{ $t('Google Recaptcha v3') }}
        el-form-item(:label="$t('Website key')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)
        el-form-item(:label="$t('Private key')")
            el-input(type="input" v-model="private" maxlength="255" show-word-limit)
</template>

<i18n>
{
    "de": {
        "Google Recaptcha v3": "Google Recaptcha v3",
        "Website key": "Webseitenschlüssel",
        "Private key": "Geheimer Schlüssel"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { useSettingsStore, useCmsWizardStore } from '@/stores'

export default {
    name: 'GoogleRecaptchaKeys',
    props: {
        cms: {
            type: Object,
            required: true,
        },
        storeModule: {
            type: String,
            default: 'settings/form',
        },
    },
    data() {
        return {
            key: 'google-recaptcha-v3',
        }
    },
    computed: {
        isWizardMode() {
            return this.storeModule === 'cmsWizard';
        },
        k() {
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        public: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        private: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.private`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'private',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        }
    },
    mounted() {
        if (this.k < 0) {
            if (this.isWizardMode) {
                useCmsWizardStore().addCmsApiKey(this.key);
            } else {
                useSettingsStore().addFormCmsApiKey(this.key);
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    .google-recaptcha-keys
        padding-left: 12px
        position: relative
        &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 4px
            background: rgba($color-grey-text, .2)
            border-radius: 6px
        h4
            color: $color-grey-text
</style>
